/**
 * This method checks whether the origin parameter is different to the different parameter.
 * If they're different, the origin will be returned, otherwise null.
 *
 * @param origin The origin parameter.
 * @param different The different parameter.
 * @returns {any} origin or null
 */
export function differentOrNull(origin: any, different: any) {
    if (origin == null || origin === different) {
        return null;
    }
    return origin;
}

/**
 * Strip html tags.
 *
 * @param {string} input
 * @returns {string}
 */
export function stripHtmlTags(input: string): string {
    return input.replace(/<[^>]+>/g, '');
}
